import { routes } from 'helpers/routes'

import type { IColumn } from 'types'
import { Breadcrumb } from 'recoils/atoms'

export const HEADERS: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 6,
  },
  {
    key: 'code',
    label: 'branch:header.id.label',
    sortable: true,
    width: 10,
  },
  {
    key: 'name',
    label: 'branch:header.name.label',
    sortable: true,
    width: 18,
  },
  {
    key: 'companyName',
    label: 'company:header.name.label',
    sortable: true,
    width: 20,
  },
  {
    key: 'phone',
    label: 'branch:header.contactNumber.label',
    sortable: false,
    width: 10,
  },
  {
    key: 'address',
    label: 'common:header.address.label',
    sortable: false,
    width: 20,
  },
  {
    key: 'isActive',
    label: 'common:header.status.label',
    sortable: true,
    width: 8,
  },
  {
    key: 'branchProducts',
    label: 'branch:header.product.label',
    sortable: false,
    width: 8,
  },
]

export const SKELETON_INFO = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
]

export const SKELETON_ADDRESS = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '170px',
  },
  {
    widthTitle: '56px',
    widthDescription: '170px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '170px',
  },
  {
    widthTitle: '150px',
    widthDescription: '272px',
  },
]

export const SKELETON_CONTACT = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
]

export const HEADERS_LOADING: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 16,
  },
  {
    key: 'name',
    label: 'branch:header.name.label',
    sortable: true,
    width: 16,
  },
  {
    key: 'companyName',
    label: 'company:header.name.label',
    sortable: true,
    width: 26,
  },
  {
    key: 'phone',
    label: 'branch:header.contactNumber.label',
    sortable: false,
    width: 10,
  },
  {
    key: 'address',
    label: 'common:header.address.label',
    sortable: false,
    width: 32,
  },
]

export const BREADCRUMBS_LIST: Breadcrumb[] = [
  { key: routes.branch.path, label: 'layout:branchManagement.breadcrumb' },
]

export const BREADCRUMBS_CREATE: Breadcrumb[] = [
  { key: routes.branch.path, label: 'layout:branchManagement.breadcrumb' },
  {
    key: routes.branch.create.path,
    label: 'layout:createBranch.breadcrumb',
  },
]

export const renderBreadcrumbsEdit = (id: string): Breadcrumb[] => [
  { key: routes.branch.path, label: 'layout:branchManagement.breadcrumb' },
  {
    key: `${routes.branch.path}/${id}/detail`,
    label: 'layout:detailBranch.breadcrumb',
  },
  {
    key: `${routes.branch.path}/${id}/edit`,
    label: 'layout:editBranch.breadcrumb',
  },
]

export const renderBreadcrumbsDetail = (id: string): Breadcrumb[] => [
  {
    key: routes.branch.path,
    label: 'layout:branchManagement.breadcrumb',
  },
  {
    key: `${routes.branch.path}/${id}/detail`,
    label: 'layout:detailBranch.breadcrumb',
    active: true,
  },
]

export const BRANCHTEMPLATE = 'branchImportTemplate'
